<template>
  <v-data-table
    :headers="tableHeaders"
    :items="filteredProducts"
    multi-sort
    item-key="name"
    :expanded.sync="expanded"
    :single-expand="singleExpand"
    :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
    :options.sync="options"
    no-data-text="Nenhum produto adicionado ainda"
  >
    <!-- table content -->
    <template v-slot:item="{ item, expand, isExpanded, index }">
      <tr>
        <td>
          <div v-if="isMultipleEans(item)">
            <mf-button color="marca-1" type="icon" :icon="isExpanded ? 'indeterminate_check_box' : 'add_box'" size="sm" @click="expand(!isExpanded)" />
          </div>
        </td>
        <td>
          {{ item.sku }}
        </td>
        <td>
          <div class="py-0">
            <span v-if="item.product && item.product.eans && item.product.eans.length > 1">
              {{ getEansCount(item) }}
            </span>
            <span v-else style="word-break: keep-all">
              {{ item.eans[0] }}
            </span>
          </div>
        </td>
        <td>
          <mf-tooltip top max-width="250px">
            <template v-slot:activator="{ on }">
              <span>{{ putEllipsis(item.name, 25) }}</span>
            </template>
            <span>{{ item.name }}</span>
          </mf-tooltip>
        </td>
        <td>R$ {{ isGroup ? group.price_1 : item.price_1 | localeString(2) }}</td>
        <td>R$ {{ isGroup ? group.price_2 : item.price_2 | localeString(2) }}</td>
        <td>{{ isGroup ? group.minimum_per_client : item.minimum_per_client }}</td>
        <td>{{ isGroup ? group.maximum_per_client : item.maximum_per_client }}</td>
        <td>{{ item.active ? 'Ativo' : 'Inativo' }}</td>
      </tr>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td class="expanded-itens" :colspan="headers.length">
        <v-checkbox v-for="ean in toSet(item.product.eans)" :key="ean" v-model="item.eans" :value="ean" :label="ean" disabled color="marca-1" multiple />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { offerSalesTables } from '@/modules/campanhas/gestao-ofertas-v2/views/mixins/offer-sales-tables.js'
export default {
  name: 'AbsoluteOfferSales',
  mixins: [offerSalesTables],

  data: () => ({
    expanded: [],
    singleExpand: true,
  }),
  computed: {
    isGroup() {
      return !!this.group
    },
    tableHeaders() {
      return [
        {
          text: '',
          value: 'expandAction',
          width: '50px',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '8%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Preço 1',
          value: 'price1',
          width: '10%',
          sortable: false,
        },
        {
          text: this.hasSegments ? 'Preço 3' : 'Preço 2',
          value: 'price2',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Mín. CPF',
          value: 'min',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Máx. CPF',
          value: 'max',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: '10%',
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}

.expanded-itens {
  padding-left: 19%;
}

::v-deep th,
::v-deep td {
  padding: 0 8px;
}
</style>
